import React from 'react';
import Herobanner from './Heroheader';
import PopularDishes from './PopularDishes';
import OurServices from './OurServices';
import BookNowForm from './BookNowForm';
import TrustedBy from './TrustedBy';
import CountUpCards from './CountUpCards';
import OwnerBanner from './OwnerBanner';
import FestivalSlider from './FestivalSlider';
import GalleryContainer from './GalleryContainer';
import EventSlider from './Sliders/EventSlider';
import TestimonialSlider from './Sliders/TestimonialSlider';
const HomePage = () => (
	<div>
		<Herobanner />

		<PopularDishes />

		<OurServices />
		<EventSlider />
		<BookNowForm />

		<CountUpCards />

		<TrustedBy />

		<FestivalSlider />

		<OwnerBanner />
		<GalleryContainer />

		<TestimonialSlider />
	</div>
);

export default HomePage;
